<div [ngClass]="{ 'e11-flex-col': !inline, 'e11-items-center e11-gap-2': inline }" class="e11-flex">
  <div class="e11-flex">
    <img [src]="logoUrl" class="e11-h-24" />
    <e11-tooltip [color]="'dark'" [hideTooltip]="!showTooltip" [tooltipText]="'Apply with your Cnect profile!' | translate">
      <span *ngIf="showTooltip" class="material-icons-outlined e11-text-skin-primary-accent e11--ml-1 e11-text-sm e11-cursor-help"> info </span>
    </e11-tooltip>
  </div>
  <span [ngClass]="{ 'e11--mt-2': !inline }" class="e11-text-xs e11-text-skin-primary-accent">{{ 'Quick Apply' | translate }}</span>
</div>
